/**
 * Night sky visual component.
 *
 * Renders a dark background with randomly positioned, twinkling stars and a
 * moon element. Displayed when the sun is below the horizon (UV index 0).
 */
import React, { useState, useEffect } from "react";
import "./NightSky.css";

const NightSky = () => {
  const [stars, setStars] = useState([]);

  // Generate random star positions
  const generateStars = (count) => {
    return Array.from({ length: count }, (_, i) => ({
      id: i,
      top: Math.random() * 100,
      left: Math.random() * 100,
      size: Math.random() * 2 + 2, // Smaller stars (2-4px)
      animationDelay: Math.random() * 4,
      animationDuration: Math.random() * 3 + 2, // Slower twinkling
      brightness: Math.random() * 0.4 + 0.6, // Varying brightness (0.6-1.0)
    }));
  };

  // Generate stars only once when component mounts
  useEffect(() => {
    setStars(generateStars(40)); // Fewer but more prominent stars
  }, []);

  return (
    <div className="night-sky">
      {stars.map((star) => (
        <div
          key={star.id}
          className="star"
          style={{
            top: `${star.top}%`,
            left: `${star.left}%`,
            width: `${star.size}px`,
            height: `${star.size}px`,
            animationDelay: `${star.animationDelay}s`,
            animationDuration: `${star.animationDuration}s`,
            "--star-brightness": star.brightness,
          }}
        />
      ))}
      <div className="moon" />
    </div>
  );
};

export default NightSky;
